import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/react'
import { itIT } from '@clerk/localizations'
import { ui } from '@clerk/ui'
import './index.css'
import App from './App.jsx'

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY
const APP_URL = import.meta.env.VITE_APP_URL

const isValidClerkKey = (key) =>
  typeof key === 'string' && /^pk_(test|live)_[a-zA-Z0-9]+$/.test(key)

if (!isValidClerkKey(PUBLISHABLE_KEY)) {
  throw new Error('Missing or invalid VITE_CLERK_PUBLISHABLE_KEY.')
}

if (!APP_URL) {
  throw new Error('Missing VITE_APP_URL.')
}

const localization = {
  ...itIT,
  signIn: {
    ...itIT.signIn,
    start: {
      ...itIT.signIn?.start,
      subtitle: '{{applicationName}}',
    },
    emailCode: {
      ...itIT.signIn?.emailCode,
      resendButton: 'Reinvia codice',
    },
    emailLink: {
      ...itIT.signIn?.emailLink,
      resendButton: 'Reinvia link',
    },
    phoneCode: {
      ...itIT.signIn?.phoneCode,
      resendButton: 'Reinvia il codice',
    },
    phoneCodeMfa: {
      ...itIT.signIn?.phoneCodeMfa,
      resendButton: 'Reinvia il codice',
    },
  },
  signUp: {
    ...itIT.signUp,
    emailCode: {
      ...itIT.signUp?.emailCode,
      resendButton: 'Reinvia codice',
    },
    emailLink: {
      ...itIT.signUp?.emailLink,
      resendButton: 'Reinvia link',
    },
    phoneCode: {
      ...itIT.signUp?.phoneCode,
      resendButton: 'Reinvia codice',
    },
  },
  userProfile: {
    ...itIT.userProfile,
    emailAddressPage: {
      ...itIT.userProfile?.emailAddressPage,
      emailCode: {
        ...itIT.userProfile?.emailAddressPage?.emailCode,
        resendButton: 'Reinvia codice',
      },
      emailLink: {
        ...itIT.userProfile?.emailAddressPage?.emailLink,
        resendButton: 'Reinvia link',
      },
    },
  },
}

const clerkAppearance = {
  variables: {
    colorPrimary: '#5b54f0',
    fontFamily: '"Work Sans", system-ui, sans-serif',
    borderRadius: '0.5rem',
  },
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      localization={localization}
      appearance={clerkAppearance}
      ui={ui}
      allowedRedirectOrigins={[`${APP_URL}/*`, APP_URL]}
    >
      <App />
    </ClerkProvider>
  </StrictMode>,
)